import * as React from 'react';
import MemberRegistrations from './member-registrations';
import { useMemberRegistrationData } from './useMemberRegistrationData';
import LoadingTableAndKeyInsights from 'components/common/loading-table-key-insights';

type Props = {
  orgId: number;
  memberId: number;
};

export default function MemberRegistrationsContainer({
  orgId,
  memberId,
}: Props) {
  const { registrationData, registrationKeyInsights, loading } =
    useMemberRegistrationData({
      orgId,
      memberId,
    });
  if (loading) {
    return <LoadingTableAndKeyInsights />;
  }
  return (
    <MemberRegistrations
      orgId={orgId}
      registrationData={registrationData}
      registrationKeyInsights={registrationKeyInsights}
    />
  );
}
